import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import PageIntro from "@/components/feature/PageIntro";
import CtaSection from "../home/components/CtaSection";
import { pillars } from "@/data/pillars";
import { Link } from "react-router-dom";
export default function ServicesPage() {
  return (
    <>
      <Navbar />
      <main id="main-content">
        <PageIntro
          eyebrow="Our work"
          title="Knowledge. Enterprise. Shared opportunity."
        >
          <p>
            Three connected areas of work support our ambition for African
            development. Explore where to begin and what is currently in
            development.
          </p>
        </PageIntro>
        <div className="shell work-jump">
          {pillars.map((p) => (
            <a className="text-link" href={`#${p.id}`} key={p.id}>
              {p.title} ↓
            </a>
          ))}
        </div>
        {pillars.map((p) => (
          <section id={p.id} key={p.id} className="section-space work-section">
            <div className="shell purpose-grid items-center">
              <img
                className="regional-image"
                src={p.image}
                alt=""
                loading="lazy"
                width="800"
                height="600"
              />
              <div>
                <span className="status-badge">{p.status}</span>
                <h2>{p.title}</h2>
                <p className="large-copy">{p.description}</p>
                <p className="body-copy">{p.detail}</p>
                <Link className="button button-green" to={p.link}>
                  {p.action} <span aria-hidden="true">↗</span>
                </Link>
              </div>
            </div>
          </section>
        ))}
        <section id="service-scope" className="section-space bg-[#F8F6F3]">
          <div className="shell">
            <p className="eyebrow">Availability & scope</p>
            <h2>Know what to expect.</h2>
            <div className="scope-list">
              {[
                [
                  "Trading Academy",
                  "In development · Register interest",
                  "Dates, duration, fees, instructors, and confirmed delivery formats will be shared before enrollment. Interest registration does not reserve a place or require payment.",
                ],
                [
                  "Advisory",
                  "Inquiry stage",
                  "Tell us about your goals. Scope, availability, fees, and any specialist requirements are discussed before an engagement is agreed.",
                ],
                [
                  "Workforce development",
                  "Planned",
                  "We welcome conversations with education and employer partners. Courses and employment placements are not currently promised.",
                ],
                [
                  "Family office, private credit & private equity",
                  "Planned",
                  "These are future areas of work, not currently advertised investment products or confirmed capital access. Any future engagement depends on appropriate qualification and review.",
                ],
              ].map(([name, status, desc]) => (
                <div key={name}>
                  <h3>{name}</h3>
                  <div>
                    <strong>{status}</strong>
                    <p className="body-copy">{desc}</p>
                  </div>
                </div>
              ))}
            </div>
            <p className="scope-note">
              The website provides general information and education. It does
              not constitute an offer of securities or personalized investment,
              legal, or accounting advice. Trading involves risk and no
              financial outcomes are guaranteed.
            </p>
          </div>
        </section>
        <CtaSection />
      </main>
      <Footer />
    </>
  );
}
